import React from 'react';
import { createIcon } from '../../../utils';

const IconWhatsapp = createIcon({
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M20.534 3.50621C18.2717 1.24388 15.2647 0 12.0684 0C8.86816 0 5.86112 1.24388 3.59879 3.50621C1.33646 5.76853 0.0885609 8.77558 0.0885609 11.9758C0.0885609 13.7672 0.499161 15.5666 1.27608 17.1768L0 24L6.71453 22.6917C8.36498 23.5169 10.2127 23.9517 12.0644 23.9517C15.2647 23.9517 18.2717 22.7078 20.534 20.4455C22.7964 18.1832 24.0403 15.1761 24.0403 11.9758C24.0443 8.77558 22.7964 5.76853 20.534 3.50621Z"
        fill="#E6E6E6"
      />
      <path
        d="M20.4658 3.57861C18.2196 1.33641 15.2407 0.100586 12.0686 0.100586C8.89655 0.100586 5.91366 1.33641 3.67146 3.57861C1.42523 5.82081 0.189408 8.80371 0.189408 11.9758C0.189408 13.7752 0.600008 15.5545 1.38095 17.1647L0.125 23.8711L6.73084 22.587C8.37726 23.4163 10.2089 23.851 12.0686 23.851C15.2407 23.851 18.2236 22.6152 20.4658 20.373C22.708 18.1308 23.9439 15.1479 23.9439 11.9758C23.9439 8.80371 22.708 5.82081 20.4658 3.57861Z"
        fill="white"
      />
      <path
        d="M12.0677 1.71094C6.39985 1.71094 1.80273 6.30805 1.80273 11.9759C1.80273 13.7673 2.26164 15.4499 3.06674 16.9193L2.1449 21.8384L6.98355 20.8964C8.48103 21.7498 10.216 22.241 12.0637 22.241C17.7316 22.241 22.3287 17.6438 22.3287 11.9759C22.3328 6.30805 17.7356 1.71094 12.0677 1.71094Z"
        fill="url(#paint0_radial_819_30242)"
      />
      <path
        d="M18.6346 8.35324C18.538 7.53606 18.3005 6.60617 17.5356 6.17947C16.803 5.76887 15.7563 5.67226 15.2169 6.44515C14.7017 7.18584 13.3974 8.38947 14.279 9.31936L14.8587 9.92721C14.8587 9.92721 15.539 10.3459 14.601 11.4207C14.601 11.4207 13.4055 12.6766 12.8298 13.1959C12.2823 13.7434 10.97 14.8745 10.97 14.8745C9.85094 15.7601 9.46852 15.0557 9.46852 15.0557L8.88885 14.4478C8.01532 13.53 6.73118 14.7618 5.97037 15.2368C5.22565 15.7038 5.24175 16.7464 5.55574 17.4831C5.90998 18.3083 6.89623 18.6062 7.70938 18.743C10.0401 19.1375 14.6252 15.0758 14.6252 15.0758C14.6252 15.0758 18.9123 10.7041 18.6346 8.35324Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_819_30242"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.0663 1.22899) scale(25.1191)"
        >
          <stop stopColor="#65FB7E" />
          <stop offset="1" stopColor="#049E22" />
        </radialGradient>
      </defs>
    </>
  ),
});

export default IconWhatsapp;
